export default __webpack_public_path__ + "static/media/7.c791a683.jpg";